import { render } from "./SetaDireita.vue?vue&type=template&id=0ecf57ac"
const script = {}
script.render = render

export default script